import {RouterLink} from "@angular/router";
import {Component, Input} from '@angular/core';

import {appRoutes} from "@numizmat/constants";
import {AdType} from "@numizmat/enumerations";
import {ImageComponent} from "../image/image.component";

export interface AdCardMiniData {
  adId: string;
  title: string;
  imageUrl: string;
  price: number;
  adType: AdType;
}

@Component({
  selector: 'nz-ad-card-mini',
  standalone: true,
  imports: [
    ImageComponent,
    RouterLink
  ],
  templateUrl: './ad-card-mini.component.html',
  styleUrl: './ad-card-mini.component.scss'
})
export class AdCardMiniComponent {
  @Input() data!: AdCardMiniData;

  protected readonly AdTypeEnum = AdType;
  protected readonly appRoutes = appRoutes;
}
